import { render, staticRenderFns } from "./CasesRejected.vue?vue&type=template&id=4412f006&scoped=true&"
import script from "./CasesRejected.vue?vue&type=script&lang=js&"
export * from "./CasesRejected.vue?vue&type=script&lang=js&"
import style0 from "./CasesRejected.vue?vue&type=style&index=0&id=4412f006&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4412f006",
  null
  
)

export default component.exports